import React from "react";
//import gnpHeaderCss from "./header.css";

export default class portalHeader extends React.Component {
	
	state = {
		posicion: 0
	}

	render() {
		return (
			<div className="navContent">
				<div className="navMain">
					<div className="navHeader layout-row layout-align-space-between-end">
						<div className="layout-padding"><a href="https://www.gnp.com.mx"><img src={require("../img/logo-gnp.gif")} /></a></div>
						<div className="botoneraMedia">
							<div className="layout-row">
								<div className="boton"><a href="https://www.gnp.com.mx/wps/portal/portalesgnp/personas">Personas</a></div>
								<div className="boton"><a href="https://www.gnp.com.mx/wps/portal/portalesgnp/empresas">Empresas</a></div>
								<div className="boton"><a href="https://www.gnp.com.mx/wps/portal/portalesgnp/sector-publico">Sector Público</a></div>
								<div className="boton active"><a href="#">Soy Cliente</a></div>
							</div>
						</div>
						<div className="layout-padding logos"><img src={require("../img/vivir-es-increible.gif")} /></div>
					</div>
				</div>
				<div className="botoneraInferior">
					<div className="layout-row layout-align-space-start-center">
						<div className="boton flex-25 layout-row layout-align-center-center"><a href="https://www.gnp.com.mx/wps/portal/portalesgnp/personas">Personas</a></div>
						<div className="boton flex-25 layout-row layout-align-center-center"><a href="https://www.gnp.com.mx/wps/portal/portalesgnp/empresas">Empresas</a></div>
						<div className="boton flex-25 layout-row layout-align-center-center"><a href="https://www.gnp.com.mx/wps/portal/portalesgnp/sector-publico">Sector Público</a></div>
						<div className="boton flex-25 layout-row layout-align-center-center active"><a href="#">Soy Cliente</a></div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/header/portalHeader.cmpt.js